import { DataPage } from "@/features/data/data-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/data")({
  component: DataPage,
});
